import { useState, useEffect, forwardRef, useRef, Fragment } from "react";

import {
  Divider,
  Grid,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableBody,
  Button,
  IconButton,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Slide,
  Box,
  Typography,
  InputAdornment,
  Container,
} from "@mui/material";
import _ from "lodash";
import { useSnackbar } from "notistack";

import CloseIcon from "@mui/icons-material/Close";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import DeleteIcon from "@mui/icons-material/Delete";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";

import CustomLayout from "views/CustomLayout";
import CustomBreadcrumbs from "components/Breadcrumbs";
import Loader from "components/Loader";
import axiosInstance from "configs/axiosConfig";
import { APIRouteConstants } from "constants/routeConstants";
import { useNavigate } from "react-router-dom";
import { updateCartCount } from "utils/website";
import { getAccessToken } from "utils";
import {
  updateCartItemsToLocalStorage,
  removeCartItemsFromLocalStorage,
  clearCart,
  getCartItemsFromLocalStorage,
  getCartSummaryFromLocalStorage,
} from "utils/cart";
import { handleOpenAuthDialog } from "utils/auth";
import { useSelector } from "react-redux";
import CartItemNote from "./OrderNotes";
import { useModal } from "utils/SignupContext";
import FloatingCartBar from "./CartFooter";
import { customeStyle } from "utils/style";
import { useCart } from "utils/CartContext";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { formatCurrencyNew } from "utils/helper";
import PilotPOSOption from "./PilotPOSOption";
import AllowedDomainss from "./AllowedDomains";
import { useStore } from "utils/OfflineContext";
import { useStoreStatus } from "Context/StoreStatusContext";
import { useAuth } from "oidc-react";
import SaleTag from "components/SaleTag";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const Cart = ({ breadcrumbs }) => {
  // const { couponctx, orderNotesctx, updateCouponctx, saveNotectx } = useCart();
  const { pilotPOSContext, setPilotPOSContext } = useStore();
  const { checkStoreStatus } = useStoreStatus();
  const {
    messagefroAuth,
    couponctx,
    orderNotesctx,
    updateCouponctx,
    setmessagefroAuth,
    saveNotectx,
  } = useCart();
  const auth = useAuth();
  const [loader, setLoader] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [cartSubTotal, setSubTotal] = useState("");
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const [couponCode, setCouponCode] = useState();
  const [appliedCouponCode, applyCouponCode] = useState();
  const [cartSummary, setCartSummary] = useState();
  const [askLogin, openAskLogin] = useState(false);
  const [showEmpty, setEmptyCart] = useState(false);
  const [orderNotes, setOrderNotes] = useState([]);
  const [tip_amount, setTipAmount] = useState(() => {
    const savedTip = localStorage.getItem("tip_amount");
    return savedTip ? Number(savedTip) : 0;
  });
  const [tipPercentage, setTipPercentage] = useState(() => {
    const savedPercent = localStorage.getItem("tip_percentage");
    return savedPercent ? Number(savedPercent) : null;
  });
  const [isCustomTip, setIsCustomTip] = useState(() => {
    const saved = localStorage.getItem("is_custom_tip");
    return saved === "true" || saved === true;
  });

  const { isOpen, openModal, closeModal } = useModal();
  const webDetails = useSelector((state) => state.webDetails);
  const { websiteInfo } = webDetails;
  const { user } = useSelector((state) => state.userDetails);
  const prevUserRef = useRef(user);

  var token = getAccessToken();
  const [pilotPOS, setPilotPOS] = useState(false); // default

  const handlePilotChange = (event) => {
    setPilotPOS(event.target.value);
  };
  useEffect(() => {
    if (_.isEmpty(prevUserRef.current) && !_.isEmpty(user)) {
      let cartItem = getCartItemsFromLocalStorage();
      if (!_.isEmpty(cartItem)) syncCartFromLocalStorage();
      else getCartItems();
    }
    prevUserRef.current = user;
  }, [user]);

  // Smart tip handling: Convert to Custom if cart total increases
  useEffect(() => {
    if (tipPercentage && !isCustomTip && cartItems.length > 0) {
      const currentTotal =
        cartSummary?.cart_total || calculateTotalPrice(cartItems);

      // Only run tip logic if enabled
      if (websiteInfo?.tip_enabled) {
        const savedTotal =
          Number(localStorage.getItem("cart_total_when_tip_set")) || 0;

        // If cart total increased, convert to Custom tip (don't scale)
        if (savedTotal > 0 && currentTotal > savedTotal) {
          // Convert to Custom - keep the same tip amount
          setIsCustomTip(true);
          setTipPercentage(null);
          localStorage.setItem("is_custom_tip", "true");
          localStorage.removeItem("tip_percentage");
          localStorage.removeItem("cart_total_when_tip_set");
        } else {
          // Normal case: recalculate based on percentage
          const newTip = (currentTotal * tipPercentage) / 100;
          const roundedTip = Math.round(newTip * 100) / 100;

          if (roundedTip !== tip_amount) {
            setTipAmount(roundedTip);
            localStorage.setItem("tip_amount", roundedTip);
            localStorage.setItem("cart_total_when_tip_set", currentTotal);
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartItems, cartSummary, tipPercentage, isCustomTip]);

  // Clear tip if cart is empty (using showEmpty flag which is set after fetch)
  useEffect(() => {
    if (showEmpty) {
      setTipAmount(0);
      setTipPercentage(null);
      setIsCustomTip(false);
      localStorage.removeItem("tip_amount");
      localStorage.removeItem("tip_percentage");
      localStorage.removeItem("is_custom_tip");
      localStorage.removeItem("cart_total_when_tip_set");
    }
  }, [showEmpty]);

  // Sync tip from API if local state is empty but API has value (e.g. after navigation)
  useEffect(() => {
    if (cartSummary) {
      const apiTip = Number(cartSummary.tip_amount) || 0;
      const currentTotal =
        cartSummary?.cart_total || calculateTotalPrice(cartItems);

      // Only sync if tip feature is enabled
      if (websiteInfo?.tip_enabled) {
        if (apiTip === 0) {
          // API says no tip - clear everything
          setTipAmount(0);
          setTipPercentage(null);
          setIsCustomTip(false);
          localStorage.removeItem("tip_amount");
          localStorage.removeItem("tip_percentage");
          localStorage.removeItem("is_custom_tip");
          localStorage.removeItem("cart_total_when_tip_set");
        } else if (apiTip > 0) {
          // Always sync the tip amount
          if (apiTip !== tip_amount) {
            setTipAmount(apiTip);
            localStorage.setItem("tip_amount", apiTip);
          }

          // Check if this tip matches a standard percentage
          if (currentTotal > 0) {
            const percent = (apiTip / currentTotal) * 100;
            const nearest = [0, 10, 15].find(
              (p) => Math.abs(p - percent) < 0.1,
            );

            if (nearest && tipPercentage !== nearest) {
              // It matches a percentage - select that button
              setTipPercentage(nearest);
              setIsCustomTip(false);
              localStorage.setItem("tip_percentage", nearest);
              localStorage.setItem("is_custom_tip", "false");
              localStorage.setItem("cart_total_when_tip_set", currentTotal);
            } else if (!nearest && !isCustomTip) {
              // Doesn't match any percentage - make it Custom
              setIsCustomTip(true);
              setTipPercentage(null);
              localStorage.setItem("is_custom_tip", "true");
              localStorage.removeItem("tip_percentage");
              localStorage.removeItem("cart_total_when_tip_set");
            }
          }
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, [cartSummary?.tip_amount, cartSummary?.cart_total]);

  const syncCartFromLocalStorage = async () => {
    setLoader(true);
    let cartItems = getCartItemsFromLocalStorage();
    cartItems = _.map(cartItems, (product) => ({
      product: product.id,
      quantity: product.quantity,
    }));
    let res = await axiosInstance.post(
      APIRouteConstants.DASHBOARD.UPDATE_CART_ITEMS_LOCAL_STORAGE,
      cartItems,
    );
    let { data, response } = res;

    if (!_.isEmpty(data)) {
      clearCart();
      getCartItems();
      updateCartCount(true);
    }
  };

  const getCartItems = async () => {
    setLoader(true);
    let res = await axiosInstance.get(
      APIRouteConstants.DASHBOARD.GET_CART_ITEMS,
    );
    let { data, response } = res;

    if (data && data.cart_items) {
      console.log("config", data?.cart_items, data?.cart_items?.length == 0);
      if (data?.cart_items?.length == 0) {
        setEmptyCart(true);
        setCartItems([]);
      } else {
        setEmptyCart(false);
        setCartItems(data.cart_items);
      }
      getOutOfStock(data.cart_items);
      setSubTotal(data.subtotal_price);
    }
    getCartSummary();
    setLoader(false);
  };

  const getCartItemsFromLS = () => {
    let items = getCartItemsFromLocalStorage();

    setCartItems(items);
    if (items.length == 0) setEmptyCart(true);
    setCartSummary(items);
    getOutOfStock(cartItems);
  };
  function calculateTotalPrice(products) {
    return products.reduce((total, product) => {
      const unitPrice =
        product.discount_price && Number(product.discount_price) > 0
          ? product.discount_price
          : product.product_price || product.price;
      const lineTotal =
        parseFloat(unitPrice) * product.quantity +
        (Number(product.vat_amount) || 0) * product.quantity;
      return total + lineTotal;
    }, 0);
  }

  const updateCartItems = async (cartItemId, action) => {
    setLoader(true);
    let res = await axiosInstance.put(
      APIRouteConstants.DASHBOARD.UPDATE_CART_ITEMS(cartItemId),
      null,
      {
        params: { action: action },
      },
    );
    let { data, response } = res;

    if (data) {
      getCartItems();
      getCartSummary();
      updateCartCount(true);
    }
  };

  const updateCartItemsToLS = (product, action) => {
    updateCartItemsToLocalStorage(product, action);
    updateCartCount(true);
    getCartItemsFromLS();
  };

  const removeCartItem = async (cartItemId) => {
    setLoader(true);
    let res = await axiosInstance.post(
      APIRouteConstants.DASHBOARD.REMOVE_CART_ITEMS(cartItemId),
    );
    let { data, response } = res;

    if (data) {
      getCartItems();
      getCartSummary();
      updateCartCount(true);
    }
  };

  const deleteCartItemFromLocalStorage = (product) => {
    removeCartItemsFromLocalStorage(product);
    updateCartCount(true);
    getCartItemsFromLS();
  };

  const [successMsg, setSuccessMsg] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  // For vouchers
  const getCartSummary = async (coupon, manualTip) => {
    try {
      setLoader(true);
      let queryParam = {};

      if (coupon) {
        localStorage.setItem("vouchercode", couponCode);
        queryParam["voucher_code"] = coupon;
      } else if (appliedCouponCode && !coupon)
        queryParam["voucher_code"] = appliedCouponCode;
      queryParam["delivery_option"] =
        websiteInfo?.delivery_option &&
        websiteInfo?.delivery_option?.includes("shipping")
          ? "shipping"
          : "store_pickup";

      let res = await axiosInstance.get(
        APIRouteConstants.DASHBOARD.CART_SUMMARY,
        {
          params: queryParam,
        },
      );
      let { data, response } = res;

      if (data) {
        setCouponCode("");
        updateCouponctx("");
      }

      if (response && response.status == 400) {
        // enqueueSnackbar(response?.data?.detail ||'coupon not valid.', { variant: 'error' });
        setErrorMsg(
          response?.data?.detail ||
            "Voucher not found with the specified code or not valid.",
        );
        localStorage.removeItem("vouchercode");
        setCouponCode("");
        updateCouponctx("");
        getCartSummary();
      }

      if (!_.isEmpty(data)) {
        setCartSummary(data);
        if (coupon && data?.coupon && data?.coupon_discount != 0) {
          setSuccessMsg("Voucher applied successfully.");
          setmessagefroAuth("");
          // enqueueSnackbar('coupon applied successfully.', { variant: 'success' });
          // setCouponCode('')
          // updateCouponctx('')
          //  localStorage.removeItem("vouchercode")
        }
        if (coupon) applyCouponCode(coupon);
        setLoader(false);
      }
      if (res.status === 500) {
        enqueueSnackbar("something went wrong.", { variant: "error" });
      }
      setLoader(false);
    } catch (err) {
      console.log("error", err);
      setLoader(false);
    }
  };

  const [outOfStock, setOutOfStock] = useState(false);

  const getOutOfStock = (items) => {
    let isOutOfStock = false;
    for (let item of items) {
      if (item.quantity > item.count) {
        isOutOfStock = true;
      }
    }
    setOutOfStock(isOutOfStock);
  };

  const saveNote = (id, note, Item) => {
    setOrderNotes((prevNotes) => {
      const existingNoteIndex = prevNotes.findIndex(
        (item) => item.product_id === id,
      );

      if (existingNoteIndex !== -1) {
        // If the note exists, update it
        const updatedNotes = [...prevNotes];
        updatedNotes[existingNoteIndex].order_instruction = note;
        return updatedNotes;
      } else {
        // If it doesn’t exist, add a new one
        return [...prevNotes, { product_id: id, order_instruction: note }];
      }
    });
  };

  function transformData(input) {
    console.log("transformData", input);
    return Object.keys(input).map((key) => {
      return {
        product_id: key,
        order_instruction: input[key]?.order_instruction,
        break_type: input[key]?.break_type || "",
      };
    });
  }

  function validateOrderNotes(cartItems, ordernotcontxtdata) {
    // Case 1: nothing to check → valid
    if (!cartItems?.length || !ordernotcontxtdata?.length) return true;

    const cartIDs = cartItems.map((i) => i?.product_variant);

    // Case 2: loop through order note data
    for (const noteItem of ordernotcontxtdata) {
      const { product_id, order_instruction } = noteItem;

      const isItemInCart = cartIDs.includes(Number(product_id));
      console.log(
        "ordernotcontxtdata",
        cartIDs,
        isItemInCart,
        product_id,
        order_instruction,
      );
      // If product is in cart and order_instruction exists → invalid
      if (
        isItemInCart &&
        (!order_instruction || order_instruction.trim() === "")
      ) {
        return false; // ❌ not valid because note is missing
      }
    }

    return true; // ✔ all notes are filled → valid
  }

  const checkoutCart = async () => {
    setLoader(true);
    setErrorMsg("");
    let formData = {};
    if (websiteInfo?.order_note_required === true) {
      const ordernotcontxtdata = transformData(orderNotesctx);
      const isValid = validateOrderNotes(cartItems, ordernotcontxtdata);

      if (!isValid) {
        enqueueSnackbar("Please add order notes for all products.", {
          variant: "error",
        });
        setLoader(false);
        setErrorMsg("Please add order notes for all products.");
        return;
      }
    }
    // Retrieve full table number from local storage
    let tableNumber = localStorage.getItem("number");

    console.log("Number before checkout:", tableNumber);

    // Include "number" in API request only if available
    if (tableNumber) {
      formData["number"] = tableNumber;
    }

    // Retrieve voucher code if available
    const codeV = localStorage.getItem("vouchercode");
    if (couponCode || appliedCouponCode || codeV) {
      formData["voucher_code"] = couponCode || appliedCouponCode || codeV;
    }

    // Add order notes if available
    const ordernotcontxtdata = transformData(orderNotesctx);

    if (ordernotcontxtdata?.length > 0) {
      formData["products"] = orderNotes;
    }
    if (ordernotcontxtdata?.length > 0) {
      formData["products"] = ordernotcontxtdata;
    }
    if (pilotPOS === true) {
      formData["is_pilot_order"] = pilotPOS;
    }
    if (tip_amount > 0) {
      formData["tip_amount"] = tip_amount;
    }

    // Send API request
    let res = await axiosInstance.post(
      APIRouteConstants.DASHBOARD.CHECKOUT,
      formData,
    );

    if ((res && res?.response && res.status == 404) || res.status == 400) {
      console.log(
        "API Response for Checkout:",
        res,
        res?.response?.data?.error,
      );
      console.log(res, "RESPONSEEEEEE");
      if (res.response.data.error === "Invalid sequence number") {
        enqueueSnackbar("Invalid QR code, try again.", { variant: "error" });
        setLoader(false);
        return;
      }
      if (couponCode) {
        console.log(res, "RESPONSEEEEEE");
        // enqueueSnackbar(res?.data?.detail ||'coupon not valid.', { variant: 'error' });
        setErrorMsg(
          res?.response?.data?.message ||
            res?.response?.data?.detail ||
            "Voucher not found with the specified code or not valid.",
        );
        setCouponCode("");
        updateCouponctx("");
        setLoader(false);
      }
      console.log(websiteInfo, "RESPONSEEEEEE");
      if (websiteInfo?.order_note_required) {
        enqueueSnackbar(res?.response?.data?.error, { variant: "error" });
        setLoader(false);
        return;
      }
      enqueueSnackbar(
        "There is some issue while checkout, Please try again..",
        { variant: "error" },
      );
      setLoader(false);
      setCouponCode("");
      updateCouponctx("");
    }
    if (res.data) {
      if (
        res?.data?.pilot_response != null &&
        res?.data?.pilot_response?.response?.Status === true
      ) {
        console.log(
          "object",
          res?.data?.pilot_response != null &&
            res?.data?.pilot_response?.response?.Status === true,
        );
        enqueueSnackbar("Order sent to Pilot POS successfully.", {
          variant: "success",
        });
        navigate(`/order-status?orderid=${res?.data?.transaction_id}`, {
          state: { order: res?.data },
        });
        // setTimeout(() => {
        //     window.location.reload();
        // }, 300);
      } else {
        navigate("/checkout", {
          state: { orderId: res.data.transaction_id },
        });
      }
    }

    setLoader(false);
  };

  useEffect(() => {
    setErrorMsg("");
    setmessagefroAuth("");
    if (token) getCartItems();
    else getCartItemsFromLS();
  }, []);

  const [isWebsiteFunctional, setIsWebsiteFunctional] = useState(false);
  const [hasCheckedWebsiteInfo, setHasCheckedWebsiteInfo] = useState(false); // 🔹 new flag

  const getWebsiteInfo = async () => {
    setLoader(true);
    try {
      const res = await axiosInstance.get(APIRouteConstants.DASHBOARD.WEB_INFO);
      const { data } = res;
      setIsWebsiteFunctional(data.status);

      setPilotPOS(data?.is_pilot_active);
      setPilotPOSContext(data?.is_pilot_active);
    } catch (err) {
      console.error(err);
      setIsWebsiteFunctional(false);
    } finally {
      setLoader(false);
      setHasCheckedWebsiteInfo(true); // ✅ mark check as complete
    }
  };
  useEffect(() => {
    getWebsiteInfo();
    if (auth?.userData?.expires_at) {
      localStorage.setItem("token-expiry", auth?.userData?.expires_at);
    }
  }, []);

  return (
    <CustomLayout>
      <Loader open={loader} />
      <Container maxWidth="lg" disableGutters>
        <Box
          className="content-container"
          sx={{
            width: "100%",
            margin: "0 auto",
            px: { xs: 2, sm: 2, md: 3 },
            mt: {
              xs: "130px",
              md: "90px",
            },
          }}
        >
          <div className="content-containerr">
            <CustomBreadcrumbs list={breadcrumbs} name={"Cart"} />

            <Grid container className="cart-wrapper main-content-wrapper">
              <Grid container className="">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    py: { xs: 1.5, md: 2 },
                    px: { xs: 1.5, sm: 2, md: 4 },
                    backgroundColor: "#f3f4f6",
                      
                    borderRadius: "8px",
                    // border: "1px solid #e5e7eb",
                  }}
                >
                  {/* Step 1 – Shopping Cart (active) */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: { xs: "6px", sm: "10px" }, flexShrink: 0 }}>
                    <Box
                      sx={{
                        width: { xs: 34, sm: 40, md: 48 },
                        height: { xs: 34, sm: 40, md: 48 },
                        borderRadius: "50%",
                        backgroundColor: "#1a1a1a",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        flexShrink: 0,
                           border: "5px solid #e5e7eb",
                      }}
                    >
                      <ShoppingCartOutlinedIcon sx={{ fontSize: { xs: "0.95rem", sm: "1.1rem", md: "1.3rem" } }} />
                    </Box>
                    <Box sx={{ display: { xs: "none", sm: "block" } }}>
                      <Typography sx={{ fontWeight: 600, fontSize: { sm: "0.72rem", md: "0.85rem" }, color: "text.primary", letterSpacing: "0.03em", lineHeight: 1.3 }}>
                        SHOPPING CART
                      </Typography>
                      <Typography sx={{ fontSize: { sm: "0.65rem", md: "0.75rem" }, color: "text.secondary", lineHeight: 1.3 }}>
                        Review your items
                      </Typography>
                    </Box>
                    <Box sx={{ display: { xs: "block", sm: "none" } }}>
                      <Typography sx={{ fontWeight: 600, fontSize: "0.65rem", color: "text.primary", letterSpacing: "0.02em", lineHeight: 1.2 }}>
                        CART
                      </Typography>
                    </Box>
                  </Box>

                  {/* Divider */}
                  <Box sx={{ flex: 1, height: "1px", backgroundColor: "#d1d5db", mx: { xs: 1, sm: 1.5, md: 3 } }} />

                  {/* Step 2 – Checkout (inactive) */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: { xs: "6px", sm: "10px" }, flexShrink: 0 }}>
                    <Box
                      sx={{
                        width: { xs: 34, sm: 40, md: 48 },
                        height: { xs: 34, sm: 40, md: 48 },
                        borderRadius: "50%",
                        border: "1.5px solid #9ca3af",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#9ca3af",
                        flexShrink: 0,
                      }}
                    >
                      <CreditCardOutlinedIcon sx={{ fontSize: { xs: "0.95rem", sm: "1.1rem", md: "1.3rem" } }} />
                    </Box>
                    <Box sx={{ display: { xs: "none", sm: "block" } }}>
                      <Typography sx={{ fontWeight: 600, fontSize: { sm: "0.72rem", md: "0.85rem" }, color: "text.primary", letterSpacing: "0.03em", lineHeight: 1.3 }}>
                        CHECKOUT
                      </Typography>
                      <Typography sx={{ fontSize: { sm: "0.65rem", md: "0.75rem" }, color: "text.secondary", lineHeight: 1.3 }}>
                        Choose payment method
                      </Typography>
                    </Box>
                    <Box sx={{ display: { xs: "block", sm: "none" } }}>
                      <Typography sx={{ fontWeight: 600, fontSize: "0.65rem", color: "text.primary", letterSpacing: "0.02em", lineHeight: 1.2 }}>
                        CHECKOUT
                      </Typography>
                    </Box>
                  </Box>

                  {/* Divider */}
                  <Box sx={{ flex: 1, height: "1px", backgroundColor: "#d1d5db", mx: { xs: 1, sm: 1.5, md: 3 } }} />

                  {/* Step 3 – Order Complete (inactive) */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: { xs: "6px", sm: "10px" }, flexShrink: 0 }}>
                    <Box
                      sx={{
                        width: { xs: 34, sm: 40, md: 48 },
                        height: { xs: 34, sm: 40, md: 48 },
                        borderRadius: "50%",
                        border: "1.5px solid #9ca3af",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#9ca3af",
                        flexShrink: 0,
                      }}
                    >
                      <CheckCircleOutlineOutlinedIcon sx={{ fontSize: { xs: "0.95rem", sm: "1.1rem", md: "1.3rem" } }} />
                    </Box>
                    <Box sx={{ display: { xs: "none", sm: "block" } }}>
                      <Typography sx={{ fontWeight: 600, fontSize: { sm: "0.72rem", md: "0.85rem" }, color: "text.primary", letterSpacing: "0.03em", lineHeight: 1.3 }}>
                        ORDER COMPLETE
                      </Typography>
                      <Typography sx={{ fontSize: { sm: "0.65rem", md: "0.75rem" }, color: "text.secondary", lineHeight: 1.3 }}>
                        Thank you for your order
                      </Typography>
                    </Box>
                    <Box sx={{ display: { xs: "block", sm: "none" } }}>
                      <Typography sx={{ fontWeight: 600, fontSize: "0.65rem", color: "text.primary", letterSpacing: "0.02em", lineHeight: 1.2 }}>
                        DONE
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>

              {websiteInfo?.order_note_required && (
                <AllowedDomainss
                  orderinstruction={websiteInfo?.w_order_instruction}
                />
              )}
              {showEmpty ? (
                <Grid container className="empty-wrapper">
                  <div className="icon-wrapper">
                    <AddShoppingCartIcon />
                  </div>
                  <span className="title">YOUR CART IS CURRENTLY EMPTY</span>{" "}
                  <br />
                  <span className="description">
                    Please add some products to your shopping cart before
                    proceeding to checkout.
                  </span>
                  <span className="description">
                    Browse our shop categories to discover new arrivals and
                    special offers.
                  </span>
                  <div className="button-wrapper">
                    <Button variant="contained" href="/products">
                      RETURN TO SHOP
                    </Button>
                  </div>
                </Grid>
              ) : (
                <Grid
                  container
                  className="cart-content"
                  alignItems="flex-start"
                  spacing={{ xs: 2, md: 3 }}
                  sx={{
                    pl: 0,
                    pt: { xs: 1, md: 3 },
                    pb: { xs: 1, md: 3 },
                    px: { xs: 0, md: 0 },
                  }}
                >
                  {/* xs/sm=12: full width on mobile+small tablet | md=8: left column on tablet 900px+ */}
                  <Grid item xs={12} md={8}>
                    {/* Desktop table — shown only at md (900px+) */}
                    <Box sx={{ display: { xs: "none", md: "block" } }}>
                      <TableContainer
                        component={Paper}
                        className="cart-table"
                        sx={{
                          borderRadius: "6px",
                          border: "1px solid #d1d5db",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                          overflow: "hidden",
                        }}
                      >
                        <Table aria-label="simple table">
                          <TableHead className="cart-table-header">
                            <TableRow>
                              <TableCell width="60%" padding="normal">
                                <Typography
                                  sx={{
                                    fontSize:
                                      customeStyle.typography.subhading1,
                                  }}
                                  variant="h6"
                                >
                                  PRODUCT
                                </Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Typography
                                  sx={{
                                    fontSize:
                                      customeStyle.typography.subhading1,
                                  }}
                                  variant="h6"
                                >
                                  QUANTITY
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography
                                  sx={{
                                    fontSize:
                                      customeStyle.typography.subhading1,
                                  }}
                                  variant="h6"
                                >
                                  SUBTOTAL
                                </Typography>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {cartItems.map((item, i) => (
                              <Fragment key={i}>
                                <TableRow key={i}>
                                  <TableCell
                                    sx={{
                                      borderBottom: "none",
                                      borderTop:
                                        i > 0 ? "1px solid #f3f4f6" : "none",
                                      verticalAlign: "top",
                                      p: "12px 16px",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "flex-start",
                                        gap: "10px",
                                      }}
                                    >
                                      <IconButton
                                        onClick={() => {
                                          if (token) removeCartItem(item.id);
                                          else
                                            deleteCartItemFromLocalStorage(
                                              item,
                                            );
                                        }}
                                        aria-label="delete"
                                        sx={{
                                          color: "#9ca3af",
                                          p: 0.5,
                                          mt: "8px",
                                          flexShrink: 0,
                                          "&:hover": {
                                            color: "#ef4444",
                                            background: "transparent",
                                          },
                                        }}
                                      >
                                        <DeleteIcon sx={{ fontSize: 18 }} />
                                      </IconButton>
                                      <Box
                                        sx={{
                                          width: "90px",
                                          height: "90px",
                                          minWidth: "90px",
                                          flexShrink: 0,
                                          borderRadius: "8px",
                                         
                                          opacity:
                                            item.count == 0 ||
                                          item.count < item.quantity
                                              ? 0.3
                                              : 1,
                                          position: "relative",
                                        }}
                                      >
                                        <img
                                          src={
                                            item?.product_image ||
                                            item?.images?.[0]?.image ||
                                            item?.images?.[0]?.image_url
                                          }
                                          alt={item.product_name || item.name}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            display: "block",
                                          }}
                                        />
                                        <SaleTag discount={item?.discount_price} bottom={4} left={4} />
                                      </Box>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "flex-start",
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            fontSize: customeStyle.buttomfont,
                                          }}
                                          className="title"
                                        >
                                          {_.truncate(
                                            item.product_name || item.name,
                                            { length: 40 },
                                          )}
                                        </Typography>

                                        {item?.size &&
                                          item?.size !== "" &&
                                          item?.size !== "null" && (
                                            <Typography
                                              sx={{
                                                fontSize:
                                                  customeStyle.buttomfont1,
                                                color: "var(--text-muted)",
                                              }}
                                            >
                                              {(() => {
                                                let size = "";

                                                // Case 1: item.size.name exists and not empty
                                                if (item?.size?.name?.trim()) {
                                                  size = item.size.name;
                                                }
                                                // Case 2: item.size is a string
                                                else if (
                                                  typeof item?.size ===
                                                    "string" &&
                                                  item.size.trim()
                                                ) {
                                                  size = item.size;
                                                }

                                                return size
                                                  ? `Size: ${_.truncate(size, { length: 40 })}`
                                                  : "";
                                              })()}
                                            </Typography>
                                          )}

                                        {item?.color &&
                                          item?.color !== "" &&
                                          item?.color !== "null" && (
                                            <Typography
                                              sx={{
                                                fontSize:
                                                  customeStyle.buttomfont1,

                                                color: "var(--text-muted)",
                                              }}
                                              className="title"
                                            >
                                              {(() => {
                                                let color = "";

                                                // Case 1: item.color.name exists and not empty
                                                if (item?.color?.name?.trim()) {
                                                  color = item.color.name;
                                                }
                                                // Case 2: item.color is a plain string
                                                else if (
                                                  typeof item?.color ===
                                                    "string" &&
                                                  item.color.trim()
                                                ) {
                                                  color = item.color;
                                                }

                                                return color
                                                  ? `Color: ${_.truncate(color, { length: 40 })}`
                                                  : "";
                                              })()}
                                            </Typography>
                                          )}

                                        {item.vat_amount > 0 && (
                                          <Typography sx={{ fontSize: "var(--fs-xs)", color: "var(--text-gray)" }}>
                                            VAT: {formatCurrencyNew(item.vat_amount, websiteInfo?.currency_symbol)}
                                          </Typography>
                                        )}

                                        {/* <span>
                                          {formatCurrencyNew(
                                            item.product_price || item.price,
                                            websiteInfo?.currency_symbol,
                                          )}
                                        </span> */}
                                       <>
  {item.discount_price && Number(item.discount_price) > 0 ? (
    <span
      style={{
        display: "flex",          // 🔥 row layout
        alignItems: "center",
        gap: "6px",
      }}
    >
      {/* Discount Price FIRST */}
      <span style={{ color: "#111", fontWeight: 600 }}>
        {formatCurrencyNew(
          item.discount_price,
          websiteInfo?.currency_symbol
        )}
      </span>

      {/* Original Price (cut) */}
      <span
        style={{
          textDecoration: "line-through",
          color: "#9e9e9e",
          fontSize: "0.8em",
        }}
      >
        {formatCurrencyNew(
          item.product_price || item.price,
          websiteInfo?.currency_symbol
        )}
      </span>
    </span>
  ) : (
    <span style={{ color: "#111", fontWeight: 600 }}>
      {formatCurrencyNew(
        item.product_price || item.price,
        websiteInfo?.currency_symbol
      )}
    </span>
  )}
</>
                                        {item.count !== 0 && item.count < 6 ? (
                                          <div className="inventory-text">
                                            <span>Only {item.count} left</span>
                                          </div>
                                        ) : item.count == 0 ? (
                                          <div className="inventory-text">
                                            <span>Out of Stock</span>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Box>
                                    </Box>
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    sx={{
                                      borderBottom: "none",
                                      borderTop:
                                        i > 0 ? "1px solid #f3f4f6" : "none",
                                      verticalAlign: "top",
                                      p: "12px 16px",
                                    }}
                                  >
                                    <div className="button-group">
                                      <Button
                                        onClick={() => {
                                          if (token)
                                            updateCartItems(item.id, 0);
                                          else updateCartItemsToLS(item, 0);
                                        }}
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                          minWidth: "28px",
                                          width: "28px",
                                          height: "28px",
                                          padding: 0,
                                          fontSize: "1rem",
                                        }}
                                      >
                                        -
                                      </Button>
                                      <Button
                                        disabled
                                        variant="contained"
                                        size="small"
                                        sx={{
                                          minWidth: "28px",
                                          width: "28px",
                                          height: "28px",
                                          padding: 0,
                                          fontSize: "0.75rem",
                                        }}
                                      >
                                        {item.quantity}
                                      </Button>
                                      <Button
                                        onClick={() => {
                                          if (token)
                                            updateCartItems(item.id, 1);
                                          else updateCartItemsToLS(item, 1);
                                        }}
                                        className={
                                          item.count == 0 ||
                                          item.count <= item.quantity
                                            ? "greyout"
                                            : ""
                                        }
                                        disabled={
                                          item.count == 0 ||
                                          item.count <= item.quantity
                                        }
                                        variant="outlined"
                                        size="small"
                                        sx={{
                                          minWidth: "28px",
                                          width: "28px",
                                          height: "28px",
                                          padding: 0,
                                          fontSize: "1rem",
                                        }}
                                      >
                                        +
                                      </Button>
                                    </div>
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      borderBottom: "none",
                                      borderTop:
                                        i > 0 ? "1px solid #f3f4f6" : "none",
                                      verticalAlign: "top",
                                      p: "12px 16px",
                                    }}
                                    align="right"
                                    className={
                                      item.count == 0 ||
                                      item.count < item.quantity
                                        ? "greyout"
                                        : ""
                                    }
                                  >
                                    {/* <Typography
                                      sx={{ fontSize: customeStyle.buttomfont }}
                                    >
                                      <b>
                                        {formatCurrencyNew(
                                          item.product_subtotal_price ||
                                            item.price * item.quantity,
                                          websiteInfo?.currency_symbol,
                                        )}
                                      </b>
                                    </Typography> */}
                                    <Typography
                                      sx={{ fontSize: customeStyle.buttomfont }}
                                    >
                                      <b>
                                        {formatCurrencyNew(
                                          ((item.discount_price &&
                                          Number(item.discount_price) > 0
                                            ? item.discount_price
                                            : item.product_price ||
                                              item.price) * item.quantity) +
                                            ((item.vat_amount || 0) * item.quantity),
                                          websiteInfo?.currency_symbol,
                                        )}
                                      </b>
                                    </Typography>
                                  </TableCell>

                                  {/* <div className='overlay-card'>
                                                    <Button style={{ backgroundColor: 'rgba(255,255,255,0.8)' }} variant="outlined" color="error">
                                                        <b>Out of Stock</b>
                                                    </Button>
                                                </div> */}
                                </TableRow>
                                {/* <div className='overlay-card'>
                                                    <Button style={{ backgroundColor: 'rgba(255,255,255,0.8)' }} variant="outlined" color="error">
                                                    <b>Out of Stock</b>
                                                    </Button>
                                                    </div> */}

                                {item?.is_disabled && (
                                  <Typography color={"red"} fontSize="0.6rem">
                                    This product is no longer available — please
                                    remove it from your cart.
                                  </Typography>
                                )}

                                <CartItemNote
                                  item={item}
                                  itemId={
                                    item?.product_variant ||
                                    item.product ||
                                    item.id
                                  }
                                  onSave={(id, note, breakType) =>
                                    saveNote(id, note, breakType)
                                  }
                                  websiteInfo={websiteInfo}
                                />
                              </Fragment>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                    {/* Mobile card layout — shown below md (900px) */}
                    {/* Mobile */}
                    <Box
                      sx={{ display: { xs: "block", sm: "block", md: "none" } }}
                    >
                      <TableContainer
                        component={Paper}
                        className="cart-table"
                        sx={{
                          borderRadius: "12px",
                          border: "2px solid #d1d5db",
                          boxShadow: "none",
                          overflow: "hidden",
                        }}
                      >
                        <Table aria-label="simple table">
                          <TableBody>
                            {cartItems.map((item, i) => (
                              <Fragment key={i}>
                                <TableRow key={i}>
                                  {/* Product info cell */}
                                  <TableCell
                                    sx={{
                                      borderBottom: "none",
                                      borderTop:
                                        i > 0 ? "1px solid #f3f4f6" : "none",
                                      p: "10px 12px",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "flex-start",
                                        gap: "10px",
                                      }}
                                    >
                                      {/* Product image */}
                                      <Box
                                        sx={{
                                          width: "70px",
                                          minWidth: "70px",
                                          height: "70px",
                                          flexShrink: 0,
                                          borderRadius: "8px",
                                         
                                          opacity:
                                            item.count == 0 ||
                                            item.count < item.quantity
                                              ? 0.3
                                              : 1,
                                          position: "relative",
                                        }}
                                      >
                                        <img
                                          src={
                                            item?.product_image ||
                                            item?.images?.[0]?.image ||
                                            item?.images?.[0]?.image_url
                                          }
                                          alt={item.product_name || item.name}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            display: "block",
                                          }}
                                        />
                                        <SaleTag discount={item?.discount_price} bottom={3} left={3} />
                                      </Box>

                                      {/* Product details */}
                                      <Box
                                        sx={{
                                          flex: 1,
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "2px",
                                          minWidth: 0,
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            fontSize: "var(--fs-sm)",
                                            fontWeight: 500,
                                            lineHeight: 1.3,
                                          }}
                                        >
                                          {_.truncate(
                                            item.product_name || item.name,
                                            { length: 40 },
                                          )}
                                        </Typography>

                                        {item?.size &&
                                          item?.size !== "" &&
                                          item?.size !== "null" && (
                                            <Typography
                                              sx={{
                                                fontSize: "var(--fs-xs)",
                                                color: "var(--text-gray)",
                                              }}
                                            >
                                              {(() => {
                                                let size = "";
                                                if (item?.size?.name?.trim()) {
                                                  size = item.size.name;
                                                } else if (
                                                  typeof item?.size ===
                                                    "string" &&
                                                  item.size.trim()
                                                ) {
                                                  size = item.size;
                                                }
                                                return size
                                                  ? `Size: ${_.truncate(size, { length: 40 })}`
                                                  : "";
                                              })()}
                                            </Typography>
                                          )}

                                        {item?.color &&
                                          item?.color !== "" &&
                                          item?.color !== "null" && (
                                            <Typography
                                              sx={{
                                                fontSize: "var(--fs-xs)",
                                                color: "var(--text-gray)",
                                              }}
                                            >
                                              {(() => {
                                                let color = "";
                                                if (item?.color?.name?.trim()) {
                                                  color = item.color.name;
                                                } else if (
                                                  typeof item?.color ===
                                                    "string" &&
                                                  item.color.trim()
                                                ) {
                                                  color = item.color;
                                                }
                                                return color
                                                  ? `Color: ${_.truncate(color, { length: 40 })}`
                                                  : "";
                                              })()}
                                            </Typography>
                                          )}

                                        {item.vat_amount > 0 && (
                                          <Typography
                                            sx={{
                                              fontSize: "var(--fs-xs)",
                                              color: "var(--text-gray)",
                                            }}
                                          >
                                            VAT: {formatCurrencyNew(item.vat_amount, websiteInfo?.currency_symbol)}
                                          </Typography>
                                        )}

                                        <Typography
                                          sx={{
                                            fontSize: "var(--fs-xs)",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                            lineHeight: 1.2,
                                            mt: 0.5,
                                          }}
                                        >
                                          {item.discount_price &&
                                          Number(item.discount_price) > 0 ? (
                                            <>
                                              {/* Discount Price */}
                                              <span
                                                style={{
                                                  color: "#111",
                                                  fontWeight: 600,
                                                }}
                                              >
                                                {formatCurrencyNew(
                                                  item.discount_price,
                                                  websiteInfo?.currency_symbol,
                                                )}
                                              </span>
                                              {/* Original Price (cut) */}
                                              <span
                                                style={{
                                                  textDecoration:
                                                    "line-through",
                                                  color: "#9e9e9e",
                                                  marginRight: "6px",
                                                }}
                                              >
                                                {formatCurrencyNew(
                                                  item.product_price ||
                                                    item.price,
                                                  websiteInfo?.currency_symbol,
                                                )}
                                              </span>
                                            </>
                                          ) : (
                                            <span
                                              style={{
                                                color: "#111",
                                                fontWeight: 600,
                                              }}
                                            >
                                              {formatCurrencyNew(
                                                item.product_price ||
                                                  item.price,
                                                websiteInfo?.currency_symbol,
                                              )}
                                            </span>
                                          )}
                                        </Typography>

                                        {item.count !== 0 && item.count < 6 ? (
                                          <div className="inventory-text">
                                            <span>Only {item.count} left</span>
                                          </div>
                                        ) : item.count == 0 ? (
                                          <div className="inventory-text">
                                            <span>Out of Stock</span>
                                          </div>
                                        ) : (
                                          ""
                                        )}

                                        {/* Quantity stepper + subtotal */}
                                        <Box
                                          sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                            mt: "4px",
                                          }}
                                        >
                                          <div className="button-group">
                                            <Button
                                              onClick={() => {
                                                if (token)
                                                  updateCartItems(item.id, 0);
                                                else
                                                  updateCartItemsToLS(item, 0);
                                              }}
                                              variant="outlined"
                                              size="small"
                                            >
                                              -
                                            </Button>
                                            <Button
                                              disabled
                                              variant="contained"
                                              size="small"
                                            >
                                              {item.quantity}
                                            </Button>
                                            <Button
                                              onClick={() => {
                                                if (token)
                                                  updateCartItems(item.id, 1);
                                                else
                                                  updateCartItemsToLS(item, 1);
                                              }}
                                              className={
                                                item.count == 0 ||
                                                item.count <= item.quantity
                                                  ? "greyout"
                                                  : ""
                                              }
                                              disabled={
                                                item.count == 0 ||
                                                item.count <= item.quantity
                                              }
                                              variant="outlined"
                                              size="small"
                                            >
                                              +
                                            </Button>
                                          </div>
                                          {/* <Typography
                                            sx={{
                                              fontWeight: "var(--fw-bold)",
                                              whiteSpace: "nowrap",
                                              fontSize: "var(--fs-sm)",
                                            }}
                                          >
                                            {formatCurrencyNew(
                                              item.product_subtotal_price ||
                                                item.price * item.quantity,
                                              websiteInfo?.currency_symbol,
                                            )}
                                          </Typography> */}
                                          <Typography
                                            sx={{
                                              marginLeft: "1rem",
                                              fontWeight: "var(--fw-bold)",
                                              whiteSpace: "nowrap",
                                              fontSize: "var(--fs-sm)",
                                            }}
                                          >
                                            {formatCurrencyNew(
                                              ((item.discount_price &&
                                              Number(item.discount_price) > 0
                                                ? item.discount_price
                                                : item.product_price ||
                                                  item.price) * item.quantity) +
                                                ((item.vat_amount || 0) * item.quantity),
                                              websiteInfo?.currency_symbol,
                                            )}
                                          </Typography>
                                        </Box>
                                      </Box>
                                    </Box>
                                  </TableCell>

                                  {/* Delete icon — dedicated column */}
                                  <TableCell
                                    sx={{
                                      borderBottom: "none",
                                      borderTop:
                                        i > 0 ? "1px solid #f3f4f6" : "none",
                                      p: "10px 4px",
                                      verticalAlign: "top",
                                      width: "36px",
                                    }}
                                  >
                                    <IconButton
                                      onClick={() => {
                                        if (token) removeCartItem(item.id);
                                        else
                                          deleteCartItemFromLocalStorage(item);
                                      }}
                                      aria-label="delete"
                                      sx={{
                                        color: "#9ca3af",
                                        p: 0.5,
                                        "&:hover": {
                                          color: "#ef4444",
                                          background: "transparent",
                                        },
                                      }}
                                    >
                                      <DeleteIcon sx={{ fontSize: 18 }} />
                                    </IconButton>
                                  </TableCell>

                                  {/* <div className='overlay-card'>
                                                    <Button style={{ backgroundColor: 'rgba(255,255,255,0.8)' }} variant="outlined" color="error">
                                                    <b>Out of Stock</b>
                                                    </Button>
                                                    </div> */}
                                </TableRow>

                                {item?.is_disabled && (
                                  <Typography color={"red"} fontSize="0.6rem">
                                    This product is no longer available — please
                                    remove it from your cart.
                                  </Typography>
                                )}

                                <CartItemNote
                                  item={item}
                                  itemId={
                                    item?.product_variant ||
                                    item.product ||
                                    item.id
                                  }
                                  onSave={(id, note, breakType) =>
                                    saveNote(id, note, breakType)
                                  }
                                  websiteInfo={websiteInfo}
                                />
                              </Fragment>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md>
                    <Typography
                      sx={{
                        fontSize: customeStyle.typography.subhading1,

                        mb: 1,
                        color: "#111827",
                      }}
                    >
                      Apply Voucher (Optional)
                    </Typography>

                    <Grid
                      container
                      alignItems="stretch"
                    spacing={{ xs: 1, sm: 2 }}

                      sx={{ mb: 2 }}
                    >
                     <Grid item xs={8} sm={9}>
                        <TextField
                          id="custom-coupon-code"
                          name="custom-coupon-code"
                          // placeholder="Coupon Code"
                          label="Voucher code"
                          type="text"
                          fullWidth
                          variant="outlined"
                          size="small"
                          autoComplete="new-password"
                          defaultValue={couponCode || couponctx || ""}
                          value={couponCode || couponctx || ""}
                          // disabled={!token}
                          // onBlur={() => }
                          onChange={(e) => {
                            setCouponCode(e.target.value);
                            updateCouponctx(e.target.value);
                          }}
                          sx={{
                            "& .MuiInputLabel-root": { fontSize: "0.8rem" },
                            "& .MuiInputLabel-shrink": { fontSize: "1rem" },
                            "& .MuiInputBase-root": { height: "40px" },
                          }}
                        />
                      </Grid>
                      {/* <Grid item xs={3} className={!token ? 'greyout button-wrapper' : 'button-wrapper'}> */}
                      {console.log("message", successMsg, errorMsg, couponCode)}
                      <Grid
                        item
                        xs={4}
                        sm={3}
                        // className={
                        //   !couponCode
                        //     ? "greyout button-wrapper"
                        //     : "button-wrapper"
                        // }
                      >
                        <Button
                        fullWidth
                          variant="outlined"
                          disabled={!couponCode}
                          onClick={() => {
                            if (couponCode && !token) return;
                            setSuccessMsg(null);
                            setErrorMsg(null);
                            getCartSummary(couponCode);
                          }}
                          sx={{
                            height: "40px",
                            border: "1px solid #d1d5db",
                            fontSize: "0.75rem",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          APPLY
                        </Button>
                      </Grid>
                      {successMsg && (
                        <Grid item xs={12} sx={{ pt: "4px !important" }}>
                          <Box display="flex" alignItems="flex-start" gap={0.5}>
                            <CheckCircleIcon sx={{ fontSize: "15px", color: "#4CAF50", flexShrink: 0, mt: "2px" }} />
                            <Typography sx={{ fontSize: customeStyle.typography.subhading1, color: "#4CAF50" }}>
                              {successMsg}
                            </Typography>
                          </Box>
                        </Grid>
                      )}

                      {(errorMsg || messagefroAuth) && (
                        <Grid item xs={12} sx={{ pt: "4px !important" }}>
                          <Box display="flex" alignItems="flex-start" gap={0.5}>
                            <CancelIcon sx={{ fontSize: "15px", color: "red", flexShrink: 0, mt: "2px" }} />
                            <Typography sx={{ fontSize: customeStyle.typography.subhading1, color: "red" }}>
                              {errorMsg || messagefroAuth}
                            </Typography>
                          </Box>
                        </Grid>
                      )}
                      {!token ? (
                        <Grid
                          item
                          xs={12}
                          style={{ margin: "-0.5rem 0 1.5rem 0" }}
                          className="error-text"
                        >
                          <span>
                            *** Please{" "}
                            <a
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                              onClick={() => openModal()}
                            >
                              login
                            </a>{" "}
                            to apply additional offers.
                          </span>
                        </Grid>
                      ) : (
                        ""
                      )}
                    </Grid>
                    <div className="cart-summary">
                      <Typography
                        sx={{ fontSize: customeStyle.typography.subhading }}
                      >
                        CART TOTAL
                      </Typography>
                      <Divider className="divider" />
                      {/* <div className='calc-wrapper'>
                                    <span className='description'>
                                        Total
                                    </span>
                                    <span className='description'>
                                        <b>{formatCurrency.format(_.get(cartSummary, 'cart_total'))}</b>
                                    </span>
                                </div>
                                <Divider className='divider'/>
                                <div className='calc-wrapper'>
                                    <span className='description'>
                                        Coupon
                                    </span>
                                    <span className='description'>
                                        <b>{formatCurrency.format(_.get(cartSummary, 'coupon_discount'))}</b>
                                    </span>
                                </div> */}

                      {/* <Divider className='divider' /> */}
                      {cartSummary?.Shipping > 0 && (
                        <Grid container justifyContent="space-between" mb={1}>
                          <Typography
                            sx={{ fontSize: "0.8rem", fontWeight: 600 }}
                          >
                            Shipping
                          </Typography>
                          <Typography
                            sx={{ fontSize: "0.8rem", fontWeight: 400 }}
                          >
                            {formatCurrencyNew(
                              _.get(cartSummary, "Shipping"),
                              websiteInfo?.currency_symbol,
                            )}
                          </Typography>
                        </Grid>
                      )}
                      {cartSummary?.coupon_discount > 0 && (
                        <Grid container justifyContent="space-between" mb={1}>
                          <Typography
                            sx={{ fontSize: "0.8rem", fontWeight: 600 }}
                          >
                            Coupon Discount
                          </Typography>
                          <Typography
                            sx={{ fontSize: "0.8rem", fontWeight: 400 }}
                          >
                            {formatCurrencyNew(
                              _.get(cartSummary, "coupon_discount"),
                              websiteInfo?.currency_symbol,
                            )}
                          </Typography>
                        </Grid>
                      )}
                      {cartSummary?.coupon_discount > 0 && (
                        <Grid container justifyContent="space-between" mb={1}>
                          <Typography
                            sx={{ fontSize: "0.8rem", fontWeight: 600 }}
                          >
                            Price after discount
                          </Typography>
                          <Typography
                            sx={{ fontSize: "0.8rem", fontWeight: 400 }}
                          >
                            {formatCurrencyNew(
                              _.get(cartSummary, "price_after_coupon"),
                              websiteInfo?.currency_symbol,
                            )}
                          </Typography>
                        </Grid>
                      )}
                      {cartItems.length > 0 && websiteInfo?.tip_enabled && (
                        <>
                          <div
                            className="calc-wrapper"
                            style={{
                              flexDirection: "column",
                              alignItems: "flex-start",
                              gap: "0px",
                              paddingBottom: "0px",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: customeStyle.typography.subhading1,
                              }}
                            >
                              ADD A TIP (Optional)
                            </Typography>
                            <Typography
                              textAlign={"left"}
                              fontSize={"0.62rem !important"}
                              color={"grey.600"}
                              sx={{ py: 2, fontWeight: "" }}
                            >
                              100% of tip amount goes to the support staff.
                              Thank you.
                            </Typography>
                            <Grid
                              container
                              spacing={0.5}
                              sx={{
                                flexWrap: "nowrap",
                                overflowX: "auto",
                                pb: 1,
                                "&::-webkit-scrollbar": { display: "none" },
                              }}
                            >
                              {[0, 10, 15].map((percentage) => (
                                <Grid item xs={3} key={percentage}>
                                  <Button
                                    variant="contained"
                                    size="small"
                                    fullWidth
                                    onClick={() => {
                                      setTipPercentage(percentage);
                                      setIsCustomTip(false);
                                      // Calculate tip based on subtotal
                                      const subTotal =
                                        cartSummary?.cart_total ||
                                        calculateTotalPrice(cartItems);
                                      const tip = (subTotal * percentage) / 100;
                                      const roundedTip =
                                        Math.round(tip * 100) / 100;
                                      setTipAmount(roundedTip);
                                      localStorage.setItem(
                                        "tip_amount",
                                        roundedTip,
                                      );
                                      localStorage.setItem(
                                        "tip_percentage",
                                        percentage,
                                      );
                                      localStorage.setItem(
                                        "is_custom_tip",
                                        "false",
                                      );
                                      localStorage.setItem(
                                        "cart_total_when_tip_set",
                                        subTotal,
                                      );
                                    }}
                                    sx={{
                                      minWidth: "unset",
                                      padding: "3px 0px",
                                      fontSize: "0.65rem",
                                      backgroundColor:
                                        tipPercentage === percentage
                                          ? "#000000"
                                          : "#FFFFFF",
                                      color:
                                        tipPercentage === percentage
                                          ? "#FFFFFF"
                                          : "#000000",
                                      fontWeight: "bold",
                                      textTransform: "none",
                                      "&:hover": {
                                        backgroundColor:
                                          tipPercentage === percentage
                                            ? "#000000"
                                            : "#000000",
                                        color: "#FFFFFF",
                                      },

                                      "&.Mui-focusVisible": {
                                        backgroundColor:
                                          tipPercentage === percentage
                                            ? "#000000"
                                            : "#FFFFFF",
                                      },
                                    }}
                                  >
                                    {percentage === 0
                                      ? "No Tip"
                                      : `${percentage}%`}
                                  </Button>
                                </Grid>
                              ))}
                              <Grid item xs={3}>
                                <Button
                                  variant="contained"
                                  size="small"
                                  fullWidth
                                  onClick={() => {
                                    setIsCustomTip(true);
                                    setTipPercentage(null);
                                    localStorage.setItem("is_custom_tip", true);
                                    localStorage.removeItem("tip_percentage");
                                  }}
                                  sx={{
                                    minWidth: "unset",
                                    padding: "3px 0px",
                                    fontSize: "0.7rem",
                                    backgroundColor: isCustomTip
                                      ? "#000000"
                                      : "#FFFFFF",
                                    color: isCustomTip ? "#FFFFFF" : "#000000",

                                    fontWeight: "bold",
                                    textTransform: "none",
                                    "&:hover": {
                                      backgroundColor: isCustomTip
                                        ? "#000000"
                                        : "#000000",
                                      color: "#FFFFFF",
                                    },

                                    "&.Mui-focusVisible": {
                                      backgroundColor: isCustomTip
                                        ? "#000000"
                                        : "#FFFFFF",
                                    },
                                  }}
                                >
                                  Custom
                                </Button>
                              </Grid>
                            </Grid>

                            {isCustomTip && (
                              <TextField
                                placeholder="Enter Tip Amount"
                                variant="outlined"
                                type="number"
                                size="small"
                                fullWidth
                                value={tip_amount || ""}
                                onChange={(e) => {
                                  const val = Number(e.target.value);
                                  if (val >= 0) {
                                    setTipAmount(val);
                                    setTipPercentage(null);
                                    setIsCustomTip(true);
                                    localStorage.setItem("tip_amount", val);
                                    localStorage.setItem(
                                      "is_custom_tip",
                                      "true",
                                    );
                                    localStorage.removeItem("tip_percentage");
                                  }
                                }}
                                sx={{
                                  mt: 1,
                                  "& .MuiInputBase-input": {
                                    padding: "10px 14px",
                                    fontSize: "14px",
                                  },
                                }}
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      {websiteInfo?.currency_symbol}
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                          </div>
                          <Divider
                            sx={{ my: 1.5, borderColor: "rgba(0,0,0,0.08)" }}
                          />
                        </>
                      )}
                      {/* <Divider sx={{ mb: 1.5, mt: 0, borderColor: 'rgba(0,0,0,0.08)' }} /> */}
                      <Grid container justifyContent="space-between" mb={1.5}>
                        <Typography
                          sx={{ fontSize: "0.8rem", fontWeight: 500 }}
                        >
                          Subtotal
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.8rem", fontWeight: 400 }}
                        >
                          {token
                            ? formatCurrencyNew(
                                _.get(cartSummary, "cart_total"),
                                websiteInfo?.currency_symbol,
                              )
                            : (() => {
                                const totalPrice =
                                  calculateTotalPrice(cartItems);
                                if (totalPrice !== 0 && !isNaN(totalPrice)) {
                                  return formatCurrencyNew(
                                    totalPrice,
                                    websiteInfo?.currency_symbol,
                                  );
                                }
                                return null;
                              })()}
                        </Typography>
                      </Grid>
                      {/* {cartSummary?.cart_total > 0 && } */}
                      {tip_amount >= 0 && websiteInfo?.tip_enabled && (
                        <Grid container justifyContent="space-between" mb={1}>
                          <Typography
                            sx={{ fontSize: "0.8rem", fontWeight: 500 }}
                          >
                            Tip Amount
                          </Typography>
                          <Typography
                            sx={{ fontSize: "0.8rem", fontWeight: 400 }}
                          >
                            {formatCurrencyNew(
                              tip_amount,
                              websiteInfo?.currency_symbol,
                            )}
                          </Typography>
                        </Grid>
                      )}
                      <Divider
                        sx={{ my: 1.5, borderColor: "rgba(0,0,0,0.08)" }}
                      />
                      <Grid container justifyContent="space-between" mb={2}>
                        <Typography
                          sx={{ fontSize: "0.9rem" }}
                          fontWeight="bold"
                        >
                          Total
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.9rem" }}
                          fontWeight="bold"
                        >
                          {(() => {
                            const totalPrice = calculateTotalPrice(cartItems);

                            const apiBasePrice =
                              cartSummary?.sub_total ||
                              cartSummary?.price_after_coupon ||
                              cartSummary?.cart_total ||
                              0;
                            const shipping = cartSummary?.Shipping || 0;
                            const finalTip = Number(tip_amount) || 0;

                            if (token) {
                              // For logged in users, use API base price (sub_total preferred) + shipping + local tip
                              // Subtract API tip if it's already in the base price to avoid double counting
                              const apiTip = websiteInfo?.tip_enabled
                                ? cartSummary?.tip_amount || 0
                                : 0;
                              const baseWithoutTip = apiBasePrice - apiTip;
                              const finalTipAmount = websiteInfo?.tip_enabled
                                ? finalTip
                                : 0;

                              return formatCurrencyNew(
                                baseWithoutTip + shipping + finalTipAmount,
                                websiteInfo?.currency_symbol,
                              );
                            } else {
                              // For guests, use local items total + local tip
                              return formatCurrencyNew(
                                totalPrice + finalTip,
                                websiteInfo?.currency_symbol,
                              );
                            }
                          })()}
                        </Typography>
                      </Grid>
                      {outOfStock ? (
                        <div className="error-text">
                          <span>
                            *** Some items from your cart are out of stock.
                            Please review your cart.
                          </span>
                        </div>
                      ) : (
                        ""
                      )}
                      {/* {pilotPOS &&  <PilotPOSOption value={pilotPOS} onChange={handlePilotChange} />} */}
                      <div className="button-wrapper">
                        {console.log("cartItems", cartItems)}
                        <Button
                          disabled={
                            _.isEmpty(cartItems) ||
                            outOfStock ||
                            cartItems?.some(
                              (item) => item?.is_disabled === true,
                            ) ||
                            (hasCheckedWebsiteInfo && !isWebsiteFunctional)
                          }
                          variant="contained"
                          sx={{
                            fontSize: customeStyle.typography.subhading,
                            textTransform: "none",
                          }}
                          onClick={async () => {
                            const isOnline = await checkStoreStatus();
                            if (!isOnline) return;
                            if (token) {
                              if (tip_amount > 0) {
                                await getCartSummary(null, tip_amount);
                              }
                              checkoutCart();
                            } else openModal();
                          }}
                        >
                          Proceed to checkout
                        </Button>
                      </div>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "6px",
                          mt: 1.5,
                          color: "text.secondary",
                        }}
                      >
                        <LockOutlinedIcon sx={{ fontSize: "0.85rem" }} />
                        <Typography
                          sx={{ fontSize: "0.7rem", color: "text.secondary" }}
                        >
                          Secure checkout
                        </Typography>
                      </Box>

                      {/* 🔴 Store Offline Notice */}
                      {hasCheckedWebsiteInfo && !isWebsiteFunctional && (
                        <div
                          style={{
                            marginTop: "12px",
                            backgroundColor: "#FFEBEE",
                            padding: "10px 12px",
                            borderRadius: "6px",
                            border: "1px solid #C62828",
                            color: "#C62828",
                            fontWeight: 600,
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            fontSize: "0.95rem",
                          }}
                        >
                          <span>⚠️</span>
                          The store is currently offline. Please try again
                          later.
                        </div>
                      )}
                    </div>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </div>

          {/* Page-bottom security notice */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              justifyContent: "center",
              gap: "8px",

              backgroundColor: "#f3f4f6",
              borderRadius: "8px",

              px: { xs: 2, sm: 3 },
              py: 2,

              mt: 2,
              mb: 4,

              width: "100%",

              color: "text.secondary",
            }}
          >
            <LockOutlinedIcon sx={{ fontSize: "1rem", flexShrink: 0, mt: "2px" }} />

            <Typography
              sx={{
                fontSize: { xs: "0.65rem", sm: "0.7rem" },
                color: "text.secondary",
                lineHeight: 1.5,
              }}
            >
              Your data is safe and secure. We use industry-standard encryption
              to protect your information.
            </Typography>
          </Box>

          <Dialog
            open={askLogin}
            TransitionComponent={Transition}
            onClose={() => {}}
            className="login-dialog-wrapper"
          >
            <DialogTitle disableTypography className="login-dialog-title">
              <IconButton
                onClick={() => {
                  openAskLogin(false);
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent className="dialog-content">
              <DialogContentText id="alert-dialog-slide-description">
                <span>Please Login to continue</span>
              </DialogContentText>
            </DialogContent>
            <DialogActions className="dialog-action">
              <Button
                variant="contained"
                color="error"
                size="small"
                onClick={() => {
                  openAskLogin(false);
                  handleOpenAuthDialog(true);
                }}
              >
                Continue
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Container>
    </CustomLayout>
  );
};

export default Cart;
